import { render, staticRenderFns } from "./inquire.vue?vue&type=template&id=6bf4410a&scoped=true&"
import script from "./inquire.vue?vue&type=script&lang=js&"
export * from "./inquire.vue?vue&type=script&lang=js&"
import style0 from "./inquire.vue?vue&type=style&index=0&id=6bf4410a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bf4410a",
  null
  
)

export default component.exports